import debounce from 'lodash/debounce';
import { useRef } from 'react';

export default (action, delay) => {
  const debouncedActionRef = useRef(debounce(action, delay));

  return (...args) => debouncedActionRef.current(...args);
};
